// extracted by mini-css-extract-plugin
export var cardSelected = "_cw-2";
export var image = "_cw-1";
export var table = "_cw-0";